import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Swal from 'sweetalert2';
import { closeModal } from '../../action/modalbehaviour.js';


const RolePermissions = () => {
    const [employees, setEmployees] = useState([]);
    const [roles, setRoles] = useState([]);
    const [rolePermissions, setRolePermissions] = useState([]);


    const [selectedRole, setSelectedRole] = useState('');
    const [selectedPermission, setSelectedPermission] = useState('');
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [selectAll, setSelectAll] = useState(false); // State for "Select All" checkbox
    
    
    const fetchData = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/role_has_permission`)
            .then(response => {
                setRoles(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching the roles!", error);
                setRoles([]);
            });
        
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/permissions`)
            .then(response => {
                setRolePermissions(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching the permissions!", error);
                setRolePermissions([]);
            });
        
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/users?users=all`)
            .then(response => {
                setEmployees(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching employees!", error);
                setEmployees([]);
            });
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Filter employees based on department
    const filteredEmployees = selectedRole 
                ? employees.filter(employee => employee.role_name.toLowerCase() === selectedRole.toLowerCase()) 
                : [];

    const handleSelectAllChange = (isChecked) => {
        if (isChecked) {
            setSelectedEmployees(filteredEmployees.map(employee => employee.id));
        } else {
            setSelectedEmployees([]);
        }
        setSelectAll(isChecked);
    }

    const handleEmployeeChange = (id, isChecked) => {
        if (isChecked) {
            setSelectedEmployees(prev => [...prev, id]);
        } else {
            setSelectedEmployees(prev => prev.filter(employeeID => employeeID !== id));
        }
    }

    const checkSelectedEmployees = async (role = '', permission = '') => {
        const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/get_employee_permissions?role=${role}&permission=${permission}`);

        if (response.data.data.length > 0) {
            setSelectedEmployees(response.data.data);
        }else{
            setSelectedEmployees([]);
        }
    }

    const handlePermissionUpdate = async () => {
        try {
            const response = await axiosInstance.post(`${process.env.REACT_APP_API_URL}/update_role_permission`, {
                permission  : selectedPermission,
                role        : selectedRole,
                employees   : selectedEmployees
            });

            Swal.fire({ icon: "success", text: response.data.message });
            closeModal(`checkUser_${selectedRole.replaceAll(' ', '_')}_${selectedPermission.replaceAll(' ', '_')}`);
            fetchData();
        } catch (error) {
            Swal.fire({ text: error.response?.data?.message || "An error occurred", icon: "error" });
        }
    }


    return(
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Role Permissions</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Role Permissions</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-hover table-bordered custom-table">
                                        <tbody>
                                            <tr className="thead-primary align-middle text-center justify-content-center">
                                                <th rowSpan={2}>Permissions</th>
                                                <th className="text-center" colSpan={Object.keys(roles).length}>Roles</th>
                                            </tr>

                                            {/* *************** ROLES *************** */}
                                            <tr className="text-center table-light">
                                                {Object.keys(roles).length > 0 && (
                                                    Object.keys(roles).map((roleName) => (
                                                        <th width={200} key={roleName}>{roleName}</th>
                                                    ))
                                                )}
                                            </tr>

                                            {/* *************** PERMISSIONS *************** */}
                                            {
                                                rolePermissions.length > 0 ? (
                                                    rolePermissions.map((permission) => (
                                                        <tr key={permission.id}>
                                                            <td className="table-light">{permission.name}</td>

                                                            {/*  =========== ROLE - PERMISION =========== */}
                                                            {
                                                                Object.keys(roles).length > 0 && (
                                                                    Object.keys(roles).map((roleName) => {
                                                                        const hasPermission = roles[roleName].includes(permission.id);

                                                                        return (
                                                                            <td className="text-center" key={`${roleName}-${permission.id}`}>
                                                                                {roleName === 'Super-Admin' ? (
                                                                                    <input type="checkbox" checked={hasPermission} disabled="disabled" />
                                                                                        // onChange={(e) => handleStateChange(e.target.checked, roleName, permission.id)}/>
                                                                                ) : (
                                                                                    <button className="btn btn-sm btn-toggle" role="button"
                                                                                        onClick={() => {
                                                                                            setSelectedPermission(permission.name);
                                                                                            setSelectedRole(roleName);
                                                                                            setSelectAll(false);
                                                                                            setSelectedEmployees([]);
                                                                                            
                                                                                            checkSelectedEmployees(roleName, permission.name);

                                                                                            // Wait for state to update, then show modal manually
                                                                                            setTimeout(() => {
                                                                                                const modalId = `#checkUser_${roleName.replaceAll(' ', '_')}_${(permission.name).replaceAll(' ', '_')}`;
                                                                                                const modal = new window.bootstrap.Modal(document.querySelector(modalId));
                                                                                                modal.show();
                                                                                            }, 1);
                                                                                        }}>
                                                                                        <i className="fa fa-search text-primary"></i>
                                                                                    </button>
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })
                                                                )
                                                            }

                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td className="text-center" colSpan={Object.keys(roles).length + 1}>No permission found</td>
                                                    </tr>
                                                ) 
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div id={`checkUser_${selectedRole.replaceAll(' ', '_')}_${selectedPermission.replaceAll(' ', '_')}`} className="modal custom-modal fade" role="dialog">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="mx-2">Role ( <b>{selectedRole}</b> ) <i className="fa fa-arrow-right"></i> Permission ( <b>{selectedPermission} </b>)</div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive m-t-15">
                                <table className="table table-striped custom-table">
                                    <thead>
                                        <tr>
                                            <th>Employees</th>
                                            <th className="text-center">
                                                {filteredEmployees.length > 0 &&
                                                    <>
                                                        Select All &nbsp;&nbsp;
                                                        <input type="checkbox" 
                                                            checked={selectAll}
                                                            onChange={(e) => handleSelectAllChange(e.target.checked)}
                                                        />
                                                    </>
                                                }
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredEmployees.length > 0 ? (
                                            filteredEmployees.map((employee) => (
                                                <tr key={employee.id}>
                                                    <td>{employee.name}</td>
                                                    <td className="text-center">
                                                        <label className="custom_check">
                                                            <input
                                                                type="checkbox"
                                                                onChange={(e) => handleEmployeeChange(employee.id, e.target.checked)}
                                                                checked={selectedEmployees.includes(employee.id)}
                                                            />
                                                            <span className="checkmark"></span>
                                                        </label>
                                                    </td>
                                                </tr>
                                            )))
                                            :
                                            <tr>
                                                <td className="text-center" colSpan="2">No employee found</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>

                                <div className="submit-section">
                                    <button type="button" className="btn btn-primary submit-btn" style={{height:"45px", width:"10px"}}
                                        onClick={handlePermissionUpdate}>UPDATE</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RolePermissions